import "../../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../../generic.view.ts';

var moment = require("moment");
import i18n  from "l10n";

export default Backbone.View.extend({
    tagName: 'div',
    now: null,
    serviceTime: null,
    logo: null,
    epsonPrinter: null,
	initialize: function (options) {
        var self = this;

        this.now = null;
        this.serviceTime = null;
        this.logo = null;

        this.render();
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
	    var self = this;
		this.superRender();
	},
	events:{

	},
	getTimestamp: function() {
	    this.now = moment();

	},
	getServiceTime: function() {
	    this.serviceTime = moment(this.now).add(this.ticketData.expectedWaitTime, 'minutes');

	},
	createData: async function() {
	    var self = this;

        var builder = new epson.ePOSBuilder();

        //builder.addTextLang("el-gr");
        builder.addTextSmooth(true);
        builder.addTextStyle(false, false, true, undefined); // BOLD
        builder.addTextFont(builder.FONT_A);
        builder.addTextAlign(builder.ALIGN_CENTER)


        if(self.queueData && self.queueData.imagePath) {
            return $.when( self.loadImage(self.queueData.imagePath) ).then(function() {
                if(self.logo && self.logo.context)
                    builder.addImage(self.logo.context, 0, 0, self.logo.width, self.logo.height, builder.COLOR_1);

                self.setBuilderTexts(builder);

                return new Promise( async (resolve, reject) => {
                    resolve(builder.toString());
                });
            });
        }
        else {
            self.setBuilderTexts(builder);

            return new Promise( async (resolve, reject) => {
                resolve(builder.toString());
            });

        }

	},
	loadImage: async function(src) {
	    var self = this;

        this.logo = {
            "width": null,
            "height": null,
            "context": null
        };

        var imagePromise = (src) => {
            return new Promise((resolve, reject) => {
               let img = new Image();

               img.onload = () => resolve(img);

               img.onerror = reject;

               img.src = window.location.origin + src;
            });
        }

        const img = await imagePromise(src);

        this.logo.width = img.width;
        this.logo.height = img.height;

        var canvas = $("<canvas width='" + self.logo.width + "' height='" + self.logo.height + "'/>")[0];
        var context = canvas.getContext('2d');

        context.drawImage(img, 0, 0);

        this.logo.context = context;

        return new Promise((resolve, reject) => {
           resolve();
        });

    },
    setBuilderTexts: function(builder) {
        //builder.addFeedLine(1);

        // Ticket Number
        builder.addTextSize(5, 4);
        builder.addText("#" + this.ticketData.number);

        builder.addFeedLine(1);
        builder.addFeedLine(1);

        // Queue Name
        builder.addTextSize(2, 2);
        builder.addText(this.queueData.name);

        builder.addFeedLine(1);
        builder.addFeedLine(1);

        // Queue Description
        builder.addTextSize(1, 1);
        builder.addText(this.queueData.description);

        builder.addFeedLine(1);
        builder.addFeedLine(1);

        // Service Time
        builder.addTextSize(1, 1);
        builder.addText("Εκτιμώμενη ώρα εξυπηρέτησης " + this.serviceTime.format('H:mm'));

        builder.addFeedLine(1);
        builder.addFeedLine(1);

        // Print Timestamp
        builder.addTextSize(1, 1);
        builder.addText(this.now.format('DD-MM-YYYY H:mm:ss'));

        builder.addFeedLine(1);
        builder.addFeedLine(1);


        // Powered by
        builder.addTextStyle(false, false, false, undefined); // NORMAL
        builder.addTextSize(1, 1);
        builder.addText("powered by mSensis");

        builder.addFeedLine(1);

        // CUT THE PAPER
        builder.addCut(builder.CUT_FEED);
    },
    sendDataToPrint: async function(options) {
        var self = this;

        this.ticketData = options ? options.ticketData : null;
        this.queueData = options ? options.queueData : null;

        if(!this.ticketData || !this.queueData) {
            console.log("NO data to print");
            $.notify(i18n.t('settings.printer.noDataToPrint'), { position:"top center", className: "error" });
            return;

        }

        await this.getPrinterConfig();

        const callback = function(status) {
            if(status == "SSL_CONNECT_OK" || status == "OK") {
                self.createAndSendData();
            }
            else {
                self.handlePrinterError(status);
            }

        }

        this.eposDevice.connect(this.printerConfig.ip, this.printerConfig.port, callback);

    },
    createAndSendData: function() {
        var self = this;

        // Set the current timestamp
        this.getTimestamp();

        // Set the Expected service Time
        this.getServiceTime();

        // Create the Data to be send to the Printer
        $.when(this.createData()).then(function(data) {

            self.epsonPrinter = new epson.ePOSPrint("https://" + self.printerConfig.ip + "/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000");

            self.setupPrinterMessages();

            self.epsonPrinter.send(data);

        });
    },
    getPrinterConfig: function() {
        var self = this;

        return $.ajaxDefaultQ({
            url: "rest/api/admin/settings/printer/" + this.queueData.id,
            type: 'GET',
            contentType: 'application/json',
            data: {}

        }).done(function (response) {

            if(response.data) {
                self.printerConfig = {
                    "ip": null,
                    "port": null
                }


                $.each(response.data, function(index, row) {

                    if(!row.value)
                        return; // $.each does not accept `continue`...

                    switch(row.name) {
                        case "PRINTER_IP":
                            self.printerConfig.ip = row.value;
                            break;
                        case "PRINTER_PORT":
                            self.printerConfig.port = row.value;
                            break;
                        default:
                            break;
                    }

                });

                if(!self.printerConfig.ip || !self.printerConfig.port) {

                    $.notify(i18n.t('settings.printer.missingConfiguration'), { position:"top center", className: "error" });

                    return;
                }

                self.createDevice(self);

            }
            else {
                $.notify(i18n.t('settings.errorOccurred'), { position:"top center", className: "error" });

            }


        }).fail(function (response) {
            console.error("response: ", response);

            $.notify(i18n.t('settings.errorOccurred'), { position:"top center", className: "error" });

        });
    },
    createDevice: function(self) {
        self.eposDevice = new epson.ePOSDevice();

    },
    handlePrinterError: function(status) {
        const queueName = i18n.lng() == "el" ? this.queueData.name : this.queueData.englishName;

        var message = i18n.t("settings.printer.error.ASB_NO_RESPONSE", {"queue": queueName});

console.log("this.queueData: ", this.queueData);
console.log("queueName: ", queueName);
console.log("message: ", message);

        $.notify(message, { position:"top center", className: "error", autoHide: false, autoHideDelay: 20000 });
    },
    setupPrinterMessages: function() {
        var self = this;

        this.epsonPrinter.oncoveropen = function () {
            console.log("Cover OPEN");

        };
        this.epsonPrinter.oncoverok = function () {
            console.log("Cover OK");
        };

        this.epsonPrinter.onstatuschange = function (status) {
            console.log("Status changed to: " + status);

        }; // WORKS, if a print event is being sent, it returns an INT containing the status code

        // Set an event callback function (paper near end)
        this.epsonPrinter.onpapernearend = function () {
            console.log('papernearend');

            $.notify(i18n.t("settings.printer.error.EPTR_REC_NEAR_EMPTY"), { position:"top center", className: "warning", autoHide: false, autoHideDelay: 20000 });

        }; // WORKS, if a print event is being sent

        this.epsonPrinter.onpaperend = function () {
            console.log('onpaperend');

            $.notify(i18n.t("settings.printer.error.EPTR_REC_EMPTY"), { position:"top center", className: "warning", autoHide: false, autoHideDelay: 20000 });
        };

        this.epsonPrinter.onpaperok = function () {
            console.log('onpaperok');

        };

        // Set a response receipt callback function
        this.epsonPrinter.onreceive = function (res) {

            if(res.success == self.epsonPrinter.ASB_PRINT_SUCCESS) {
                $.notify(i18n.t('settings.printer.printSuccess'), { position:"top center", className: "success" });
                return;
            }

            if(res.status == self.epsonPrinter.EPTR_AUTOMATICAL) {
                // Continuous printing of high-density printing

                $.notify(i18n.t('settings.printer.printSuccess'), { position:"top center", className: "error", autoHide: true, autoHideDelay: 20000 });
                return;
            }

            const statusText = self.convertPrinterCodeToText(res.status);

console.log("res.status: ", res.status);
console.log("statusText: ", statusText);

            const queueName = i18n.lng() == "el" ? this.queueData.name : this.queueData.englishName;

            var message = i18n.t("settings.printer.error.ASB_NO_RESPONSE", {"queue": queueName});

            $.notify(i18n.t("settings.printer.error." + statusText, {"queue": queueName}), { position:"top center", className: "error", autoHide: true, autoHideDelay: 20000 });

            /*// Obtain the printer status
            var asb = res.status;

            if (asb & self.epsonPrinter.ASB_NO_RESPONSE) {
                msg += ' No printer response\n';
            }
            if (asb & self.epsonPrinter.ASB_PRINT_SUCCESS) {
                msg += ' Print complete\n';
            }
            if (asb & self.epsonPrinter.ASB_DRAWER_KICK) {
                msg += ' Status of the drawer kick number 3 connector pin = "H"\n';
            }
            if (asb & self.epsonPrinter.ASB_OFF_LINE) {
                msg += ' Offline status\n';
            }
            if (asb & self.epsonPrinter.ASB_COVER_OPEN) {
                msg += ' Cover is open\n';
            }
            if (asb & self.epsonPrinter.ASB_PAPER_FEED) {
                msg += ' Paper feed switch is feeding paper\n';
            }
            if (asb & self.epsonPrinter.ASB_WAIT_ON_LINE) {
                msg += ' Waiting for online recovery\n';
            }
            if (asb & self.epsonPrinter.ASB_PANEL_SWITCH) {
                msg += ' Panel switch is ON\n';
            }
            if (asb & self.epsonPrinter.ASB_MECHANICAL_ERR) {
                msg += ' Mechanical error generated\n';
            }
            if (asb & self.epsonPrinter.ASB_AUTOCUTTER_ERR) {
                msg += ' Auto cutter error generated\n';
            }
            if (asb & self.epsonPrinter.ASB_UNRECOVER_ERR) {
                msg += ' Unrecoverable error generated\n';
            }
            if (asb & self.epsonPrinter.ASB_AUTORECOVER_ERR) {
                msg += ' Auto recovery error generated\n';
            }
            if (asb & self.epsonPrinter.ASB_RECEIPT_NEAR_END) {
                msg += ' No paper in the roll paper near end detector\n';
            }
            if (asb & self.epsonPrinter.ASB_RECEIPT_END) {
                msg += ' No paper in the roll paper end detector\n';
            }
            if (asb & self.epsonPrinter.ASB_BUZZER) {
                msg += ' Sounding the buzzer (limited model)\n';
            }
            if (asb & self.epsonPrinter.ASB_SPOOLER_IS_STOPPED) {
                msg += ' Stop the spooler\n';
            }*/

        }
        this.epsonPrinter.onerror = function (err) {
            console.error("error: ", err);

        };

        this.epsonPrinter.onpoweroff = function () {
            console.log("onpoweroff");

        }; // WORKS, if a print event is being sent, while it is closed

        this.epsonPrinter.onoffline = function () {
            console.log("onoffline");

        };

        this.epsonPrinter.ononline = function () {
            console.log("ononline");

        };

        // Enable status event operation
        this.epsonPrinter.open();

    },
    convertPrinterCodeToText: function(code) {
        switch(code) {
            case this.epsonPrinter.ASB_NO_RESPONSE:
                return "ASB_NO_RESPONSE";

            case this.epsonPrinter.ASB_RECEIPT_END:
                return "EPTR_REC_EMPTY";

            case this.epsonPrinter.ASB_RECEIPT_NEAR_END:
                return "EPTR_REC_NEAR_EMPTY";

            case this.epsonPrinter.ASB_COVER_OPEN:
                return "EPTR_COVER_OPEN";

            case this.epsonPrinter.ASB_MECHANICAL_ERR:
                return "EPTR_MECHANICAL";

            case this.epsonPrinter.ASB_AUTOCUTTER_ERR:
                return "EPTR_CUTTER";

            default:
                return "ASB_NO_RESPONSE";
        }
    }
});


